import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BuyLicenseComponent } from '../buy-license/buy-license.component';

@Component({
    selector: 'app-download-link',
    templateUrl: './download-link.component.html',
    styleUrls: ['./download-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DownloadLinkComponent {
  @Input() title = 'Stáhnout PDF';

  @Input() url: string;

  @Input() locked = false;

  constructor(private modal: NgbModal) {}

  public openBuyLicense(event) {
    this.modal.open(BuyLicenseComponent);
    event.preventDefault();
  }
}
